import { render, staticRenderFns } from "./updateAcos.vue?vue&type=template&id=1bd8f8c8"
import script from "./updateAcos.vue?vue&type=script&lang=js"
export * from "./updateAcos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports